<template>
  <div class="rubro-datos">
    <b-row>
      <b-col cols="12" xl="12">  
        <b-card header="Información del Rubro">
          <b-table 
              class="datos-objeto"
              small 
              responsive="sm" 
              :busy="tableBusy"
              :items="rubroDatos" 
              :fields="fields">
            <template v-slot:cell(valor)="data">
              {{ formattedData(data.item) }}
            </template>
            <div slot="table-busy" class="text-center">
              <b-spinner class="table-spinner" label="Spinning" />
            </div>              
          </b-table>
        </b-card>
      </b-col>
    </b-row>
    <div class="fixed-btn">
      <div class="list-dropdown-btn">
        <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
          <template slot="button-content">
            <i class="fa fa-ellipsis-v fa-2x" aria-hidden="true"></i>
          </template>
          
          <b-dropdown-item @click.stop="editar">
            <i class="fa fa-edit"></i>Editar Datos del Rubro</b-dropdown-item>
          <b-dropdown-item @click.stop="goList">
            <i class="fa fa-undo"></i>Volver al Listado</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'rubrotrabajo/getField',
  mutationType: 'rubrotrabajo/updateField',
});

export default {
  name: 'RubrosTrabajosDatos',
  components: {
    appMensaje: Mensaje
  },
  mixins: [ 
    msjModal, 
  ],
  data: () => {
    return {
      id: 0,
      fields: [
        {key: 'campo'},
        {key: 'valor'},
      ],

      tableBusy: false,
    }
  },
  created() {
    this.id= this.$route.params.id

    this.tableBusy = true;
    this.$store.dispatch('rubrotrabajo/getRubroDatos', this.id)
      .then(() => this.tableBusy = false)
      .catch(error => this.showErrorMsj(error));
  },  
  computed: {
    ...mapFields([
      'rubroDatos',
    ]),
  },  
  methods: {
    goList() {
      this.$router.push({ name: 'RubrosTrabajos' });
    },
    editar() {
      this.$router.push({ name: 'RubroTrabajosABM', 
                          params: { id: this.id }});
    },
  }
}
</script>

<style>
  .rubro-datos .datos-objeto table td[aria-colindex="1"] {
    width: 20%;
  }
  .rubro-datos .datos-objeto table td[aria-colindex="2"] {
    width: 80%;
  }
</style>